import React from 'react';
import { Label, TextInput } from 'flowbite-react';
import { useTranslation } from 'react-i18next';

interface SessionUrlInputProps {
  url: string;
  onUrlChange: (url: string) => void;
  onValidation: (field: string, value: string) => void;
}

export const SessionUrlInput: React.FC<SessionUrlInputProps> = ({
  url,
  onUrlChange,
  onValidation,
}) => {
  const { t } = useTranslation();

  const handleChange = (value: string) => {
    onUrlChange(value);
    onValidation('url', value);
  };

  return (
    <div>
      <div className="mb-2 block">
        <Label htmlFor="url" value={t('sessions.url')} />
        <span className="ms-1 text-red-500">*</span>
      </div>
      <TextInput
        id="url"
        type="url"
        placeholder={t('placeholders.url')}
        value={url}
        onChange={(e) => handleChange(e.target.value)}
        required
      />
    </div>
  );
};
